import React, { useRef } from 'react'
import { AnimatePresence } from 'framer-motion'
import { cls } from 'utilities/dom'
import { useGetItemLabel } from '../../utilities'
import {
    ListItem, Anchor,
    Label, KeyHintInner
} from './s'
import { ExternalLink, ArrowRight as Navigate } from 'styled-icons/feather'
import { itemHeight } from './constants'

const Announcement = ({ item, isActive }) => {
    const itemRef = useRef()

    const getItemLabel = useGetItemLabel()

    let {
        className = '',
        icon,
        external = false
    } = item ?? {}

    const Icon = icon ?? null

    const triggerClassName = cls([
        'neutral',
        isActive && 'active',
        !!Icon && 'has-icon',
        className
    ])

    // If message an array and the last item is not a string, remove it
    const message = Array.isArray(item.message) ?
        item.message
            .filter((_, index) => index === item.message.length - 1 ? typeof m === 'string' : true)
            .join(' ')
            .trim()
        : item.message

    const KeyHint = external ? ExternalLink : Navigate

    return (
        <ListItem
            className="command"
            style={{ '--item-height': `${itemHeight}px` }}
            ref={itemRef}>
            <Anchor
                href={item.url}
                target="_blank"
                className={triggerClassName}>
                {!!Icon && (
                    <Icon
                        size={20}
                        className="icon" />
                )}
                <Label className="rows">
                    <span className="label">
                        {getItemLabel(item)}
                    </span>
                    <span className="sub-label">
                        {message}
                    </span>
                </Label>
                {!!isActive && (
                    <AnimatePresence>
                        <KeyHintInner animate={isActive ? 'active' : 'inactive'}>
                            <KeyHint size={16} />
                        </KeyHintInner>
                    </AnimatePresence>
                )}
            </Anchor>
        </ListItem>
    )
}

export default Announcement